import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DialogService } from 'src/app/shared/services/dialog.service';

export interface pago {
	pagoId: string;
	pagoTotal: number;
	instructorFechaPago: any;
	instructorNombre: string;
	instructorId: string;
	instructorViaPago: string;
	transacciones: any;
	instructorEstatusPago: string;
}

export interface venta {
	usuarioId: string;
	usuarioEmail: string;
	usuarioNombre: string;
	usuarioTipo: string;
	cursoId: string;
	cursoTitulo: string;
	cursoPrecioOriginal: number;
	cursoPorcentajeDescuento: number;
	cursoPrecioFinal: number;
	transaccionMoneda: string;
	transaccionTax: number;
	transaccionComisionCobro: number;
	transaccionFecha: any;
	transaccionEstatusCobro: string;
	transaccionViaCobro: string;
	transaccionId: string;
	transaccionComentario: string;
	instructorId: string;
	instructorNombre: string;
	instructorPorcentaje: number;
	instructorTotal: number;
	instructorEstatusPago: string;
	instructorFechaPago: any;
	instructorViaPago: string;
	pagoId: string;
	last4: string;
}

@Component({
	selector: 'app-detalle-pago',
	templateUrl: './detalle-pago.component.html',
	styleUrls: ['./detalle-pago.component.css']
})
export class DetallePagoComponent implements OnInit {

	constructor(
		public authService: AuthService,
		public afAuth: AngularFireAuth,
		private afs: AngularFirestore,
		private route: ActivatedRoute,
		private router: Router,
		public dialog: MatDialog,
		public dialogService: DialogService
	) {
	}

	id = this.route.snapshot.paramMap.get('id');
	loaded: number = 0;
	pago: pago;
	transacciones: venta[] = [];
	token: string;
	logo: string = "assets/images/logos/logo.svg"

	ngOnInit(): void {
		this.token = JSON.parse(localStorage.getItem('token'));
		this.cargarPago();
	}

	cargarPago() {
		this.afs.collection('instructoresPagos').doc(this.id).ref.get().then(doc => {
			const data = doc.data();
			const pago: pago = {
				pagoId: this.id,
				pagoTotal: data['pagoTotal'],
				instructorFechaPago: data['instructorFechaPago'],
				instructorNombre: data['instructorNombre'],
				instructorId: data['instructorId'],
				instructorViaPago: data['instructorViaPago'],
				transacciones: data['transacciones'],
				instructorEstatusPago: data['instructorEstatusPago']
			}
			this.transacciones = pago.transacciones;
			this.pago = pago;
			this.loaded = 1;
		}).catch(error => {
			console.log(error)
		});
	}

	onDelete() {
		this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
			if (res == true) {
				this.eliminarPago()
			}
		});
	}

	async marcarPagado() {
		let transacciones = []
		for (let index = 0; index < this.transacciones.length; index++) {
			const tran: venta = {
				usuarioId: this.transacciones[index].usuarioEmail,
				usuarioEmail: this.transacciones[index].usuarioId,
				usuarioNombre: this.transacciones[index].usuarioNombre,
				usuarioTipo: this.transacciones[index].usuarioTipo,
				cursoId: this.transacciones[index].cursoId,
				cursoTitulo: this.transacciones[index].cursoTitulo,
				cursoPrecioOriginal: this.transacciones[index].cursoPrecioOriginal,
				cursoPorcentajeDescuento: this.transacciones[index].cursoPorcentajeDescuento,
				cursoPrecioFinal: this.transacciones[index].cursoPrecioFinal,
				transaccionMoneda: this.transacciones[index].transaccionMoneda,
				transaccionTax: this.transacciones[index].transaccionTax,
				transaccionComisionCobro: this.transacciones[index].transaccionComisionCobro,
				transaccionFecha: this.transacciones[index].transaccionFecha,
				transaccionEstatusCobro: this.transacciones[index].transaccionEstatusCobro,
				transaccionViaCobro: this.transacciones[index].transaccionViaCobro,
				transaccionId: this.transacciones[index].transaccionId,
				transaccionComentario: this.transacciones[index].transaccionComentario,
				instructorId: this.transacciones[index].instructorId,
				instructorNombre: this.transacciones[index].instructorNombre,
				instructorPorcentaje: this.transacciones[index].instructorPorcentaje,
				instructorTotal: this.transacciones[index].instructorTotal,
				instructorEstatusPago: 'pagado',
				instructorFechaPago: this.transacciones[index].instructorFechaPago,
				instructorViaPago: this.transacciones[index].instructorViaPago,
				pagoId: this.id,
				last4: this.transacciones[index].last4
			}
			transacciones.push(tran)
			await this.afs.collection('stripe_ventas').doc(tran.transaccionId).update(tran)
		}
		this.transacciones = transacciones;
		await this.afs.collection("instructoresPagos").doc(this.id).update({
			transacciones: this.transacciones,
			instructorEstatusPago: 'pagado',
		})
		this.cargarPago();
	}

	eliminarPago() {
		for (let index = 0; index < this.transacciones.length; index++) {
			const tran: venta = {
				usuarioId: this.transacciones[index].usuarioEmail,
				usuarioEmail: this.transacciones[index].usuarioId,
				usuarioNombre: this.transacciones[index].usuarioNombre,
				usuarioTipo: this.transacciones[index].usuarioTipo,
				cursoId: this.transacciones[index].cursoId,
				cursoTitulo: this.transacciones[index].cursoTitulo,
				cursoPrecioOriginal: this.transacciones[index].cursoPrecioOriginal,
				cursoPorcentajeDescuento: this.transacciones[index].cursoPorcentajeDescuento,
				cursoPrecioFinal: this.transacciones[index].cursoPrecioFinal,
				transaccionMoneda: this.transacciones[index].transaccionMoneda,
				transaccionTax: this.transacciones[index].transaccionTax,
				transaccionComisionCobro: this.transacciones[index].transaccionComisionCobro,
				transaccionFecha: this.transacciones[index].transaccionFecha,
				transaccionEstatusCobro: this.transacciones[index].transaccionEstatusCobro,
				transaccionViaCobro: this.transacciones[index].transaccionViaCobro,
				transaccionId: this.transacciones[index].transaccionId,
				transaccionComentario: this.transacciones[index].transaccionComentario,
				instructorId: this.transacciones[index].instructorId,
				instructorNombre: this.transacciones[index].instructorNombre,
				instructorPorcentaje: this.transacciones[index].instructorPorcentaje,
				instructorTotal: this.transacciones[index].instructorTotal,
				instructorEstatusPago: 'pendiente',
				instructorFechaPago: '',
				instructorViaPago: '',
				pagoId: '',
				last4: this.transacciones[index].last4
			}
			console.log(tran)
			this.afs.collection('stripe_ventas').doc(tran.transaccionId).update(tran)
		}
		this.afs.collection('instructoresPagos').doc(this.id).delete().then(() => {
			this.dialogService.dialogExito().afterClosed().subscribe(res => {
				this.router.navigate(['admin/pagos']);
			})
		}).catch(error => {
			this.dialogService.dialogFracaso()
			console.log(error)
		});
	}

	print() {
		window.print();
	}

}
